import { Component, EventEmitter, OnInit, Input, Output } from '@angular/core';
import { Product, ProductPicture } from 'src/app/classes';
import { WistaAMSTypes } from 'src/app/wista-ams-types';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-shop-product-dropdown-preview',
  templateUrl: './shop-product-dropdown-preview.component.html',
  styleUrls: ['./shop-product-dropdown-preview.component.css']
})
export class ShopProductDropdownPreviewComponent implements OnInit {

  productNumber: string;
  productService: string;
  productSetupCost: number = 0;
  productPurchaseCost: number = 0;
  productRentalCost: number = 0;

  productPictureData: string;
  productPictureLoading: boolean = false;

  _product: Product;
  @Input() set product(product: Product){
    this._product = product;
    this.productNumber = product.productnumber;
    this.productService = product.productservice;
    if(product.productsetupcost) this.productSetupCost = product.productsetupcost;
    if(product.productpurchasecost) this.productPurchaseCost = product.productpurchasecost;
    if(product.productrentalcost) this.productRentalCost = product.productrentalcost;
    this.productPictureLoading = true;
    this._dataService.resolve(WistaAMSTypes.ProductPicture, product.productid, (result: ProductPicture) => {
      this.productPictureData = this.getPictureData(result);
      this.productPictureLoading = false;
    });
  }
  get product(): Product {
    return this._product;
  }

  _count: number;
  @Input() set count(value: number){
    this._count = value;
  }
  get count(): number {
    return this._count;
  }
  
  @Output() onAdd: EventEmitter<any> = new EventEmitter();

  constructor(
    private _dataService: DataService
  ) { }

  addProduct(){
    this.onAdd.emit();
  }
  /**
   * the method generates the img src data for an image
   */
  getPictureData(picture: ProductPicture) {
    return "data:" + picture.picturemediatype + ";base64," + picture.picturedata;
  }

  ngOnInit(): void {
  }

}
